var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/martech/Homepage/HomePageBannerWrapper/HomePageBannerWrapper.jsx";

/* eslint-disable zillow/react/no-danger */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useYieldCallback } from '@zillow/yield-callback';
import HomePageBanner from './HomePageBanner';
import { NewLaneEvent } from '../../../../../eventing/NewLaneEvent';
import { DSP_BRAND, DSP_EXPERIENCE } from '../../../../internal/constants';
import { formNewLaneEventPayload } from '../../../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../../../eventing/clickStreamEventSchema';
import { useOnsiteMessagingImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent';
export var HomePageBannerWrapper = function HomePageBannerWrapper(_ref) {
  var actionLink = _ref.actionLink,
      actionText = _ref.actionText,
      adImage = _ref.adImage,
      bgImage = _ref.bgImage,
      description = _ref.description,
      eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      gaImpressionCategory = _ref.gaImpressionCategory,
      gaImpressionAction = _ref.gaImpressionAction,
      gaImpressionLabel = _ref.gaImpressionLabel,
      gaEngagementCategory = _ref.gaEngagementCategory,
      gaEngagementAction = _ref.gaEngagementAction,
      gaEngagementLabel = _ref.gaEngagementLabel,
      gaHoverCategory = _ref.gaHoverCategory,
      gaHoverAction = _ref.gaHoverAction,
      gaHoverLabel = _ref.gaHoverLabel,
      headline = _ref.headline,
      onAction = _ref.onAction,
      legalText = _ref.legalText;
  var ref = useOnsiteMessagingImpressionEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    gaEventData: {
      category: gaImpressionCategory,
      action: gaImpressionAction,
      label: gaImpressionLabel
    }
  });
  var onClickAction = useYieldCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'click'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData);

    if (gaEngagementCategory) {
      NewLaneEvent(oldDspPayload, newLanePayload, {
        category: gaEngagementCategory,
        action: gaEngagementAction,
        label: gaEngagementLabel
      });
    } else {
      NewLaneEvent(oldDspPayload, newLanePayload);
    }

    onAction();

    if (actionLink) {
      window.open(actionLink, '_self');
    }
  }, [gaEngagementCategory, eventData, newLaneEventData, additionalClickStreamData, onAction, actionLink, gaEngagementAction, gaEngagementLabel]);
  var onHoverAction = useCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'hover'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.HOVER, newLaneEventData, additionalClickStreamData);

    if (gaHoverCategory) {
      NewLaneEvent(oldDspPayload, newLanePayload, {
        category: gaHoverCategory,
        action: gaHoverAction,
        label: gaHoverLabel
      });
    } else {
      NewLaneEvent(oldDspPayload, newLanePayload);
    }
  }, [gaHoverCategory, eventData, newLaneEventData, additionalClickStreamData, gaHoverAction, gaHoverLabel]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HomePageBanner, {
    adImage: adImage,
    bgImage: bgImage,
    buttonText: actionText,
    clickAction: onClickAction,
    hoverAction: onHoverAction,
    description: description,
    headline: headline,
    legalText: legalText,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 13
    }
  }));
};
HomePageBannerWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The action link for clicking on the component
   */
  actionLink: PropTypes.string.isRequired,

  /**
   * The action text displayed in component
   * */
  actionText: PropTypes.string.isRequired,

  /**
   * Background image displayed in component
   */
  bgImage: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),

  /**
   * The heading displayed in component.
   * */
  headline: PropTypes.string.isRequired,

  /**
   * The description/body text displayed in component.
   * Should not exceed 2 lines when screen width is 1025px.
   * */
  description: PropTypes.string.isRequired,

  /**
   * Advertisement image displayed in component
   */
  adImage: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),

  /**
   * Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  eventData: PropTypes.object,

  /**
   * New Lane Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,

  /**
   * Additional Clickstream data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object,

  /**
   * The impression GA event's category
   */
  gaImpressionCategory: PropTypes.string,

  /**
   * The impression GA event's action
   */
  gaImpressionAction: PropTypes.string,

  /**
   * The impression GA event's label
   */
  gaImpressionLabel: PropTypes.string,

  /**
   * The engagement GA event's category
   */
  gaEngagementCategory: PropTypes.string,

  /**
   * The engagement GA event's action
   */
  gaEngagementAction: PropTypes.string,

  /**
   * The engagement GA event's label
   */
  gaEngagementLabel: PropTypes.string,

  /**
   * The hover GA event's category
   */
  gaHoverCategory: PropTypes.string,

  /**
   * The hover GA event's action
   */
  gaHoverAction: PropTypes.string,

  /**
   * The hover GA event's label
   */
  gaHoverLabel: PropTypes.string,

  /**
   * The action on clicking this component.
   */
  onAction: PropTypes.func,

  /**
   * Legal text displayed at the bottom below the CTA button. Supports html.
   * If you want to update css, use class selector hp-banner-legal-text and apply css overrides.
   */
  legalText: PropTypes.string
} : {};
HomePageBannerWrapper.defaultProps = {
  adImage: {},
  bgImage: {},
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  gaImpressionCategory: null,
  gaImpressionAction: 'display',
  gaImpressionLabel: null,
  gaEngagementCategory: null,
  gaEngagementAction: 'click',
  gaEngagementLabel: null,
  gaHoverCategory: null,
  gaHoverAction: 'hover',
  gaHoverLabel: null,
  onAction: function onAction() {},
  legalText: ''
};